import {Routes} from "@angular/router";
import {mainViewComponent} from "./views/main-view/main-view.component";
import {minorViewComponent} from "./views/minor-view/minor-view.component";
import {loginComponent} from "./views/login/login.component";
import {registerComponent} from "./views/register/register.component";
import {blankComponent} from "./components/common/layouts/blank.component";
import {basicComponent} from "./components/common/layouts/basic.component";
import {AuthGuard} from "./util/authGuard";
import { EmpresasComponent } from './views/empresas/empresas.component';
import { ConductoresComponent } from './views/conductores/conductores.component';
import { VehiculosComponent } from './views/vehiculos/vehiculos.component';
import { TipoServicioComponent } from './views/tipoServicio/tipoServicio.component';
import { ClientesComponent } from './views/clientes/clientes.component';
import { UsuariosComponent } from './views/usuarios/usuarios.component';
import { ConfiguracionesComponent } from './views/configuraciones/configuraciones.component';
import { RecargaReporte } from './views/recargaReporte/recargaReporte.component';
import { ServicioReporte } from "./views/servicioReporte/servicioReporte.component";
import { GeolocalizacionComponent } from "./views/geolocalizacion/geolocalizacion.component";
import { cambiarClaveComponent } from './views/cambiarClave/cambiarClave.component';
import { recuperarClaveComponent } from "./views/recuperarClave/recuperarClave.component";
import { verificarEmailComponent } from './views/verificarEmail/verificarEmail.component';
import { ConductorReporte } from './views/conductorReporte/conductorReporte.component';
import { ClienteReporte } from './views/clienteReporte/clienteReporte.component';
import { EstadisticasReporte } from "./views/estadisticasReporte/estadisticasReporte.component";


export const ROUTES: Routes = [
  // Main redirect
  {path: '', redirectTo: 'conductores', pathMatch: 'full' },

  // App views
  {
    path: '', component: basicComponent, canActivate: [AuthGuard],
    children: [
      {path: 'mainView', component: mainViewComponent},
      {path: 'minorView', component: minorViewComponent},
      {path: 'empresas', component: EmpresasComponent},
      {path: 'conductores', component: ConductoresComponent},
      {path: 'vehiculos', component: VehiculosComponent},
      {path: 'tipoServicios', component: TipoServicioComponent},
      {path: 'clientes', component: ClientesComponent},
      {path: 'usuarios', component: UsuariosComponent},
      {path: 'configuraciones', component: ConfiguracionesComponent},
      {path: 'recargaReporte', component: RecargaReporte},
      {path: 'conductorReporte', component: ConductorReporte},
      {path: 'clienteReporte', component: ClienteReporte},
      {path: 'estadisticasReporte', component: EstadisticasReporte},
      {path: 'servicioReporte', component: ServicioReporte},
      {path: 'geolocalizacion', component: GeolocalizacionComponent},
      {path: 'cambiarClave', component: cambiarClaveComponent},
    ]
  },
  {
    path: '', component: blankComponent,
    children: [
      { path: 'login', component: loginComponent },
      { path: 'register', component: registerComponent },
      { path: 'recuperarClave', component: recuperarClaveComponent },
      { path: 'verificarEmail/:token', component: verificarEmailComponent }
    ]
  },

  // Handle all other routes
  {path: '**',    component: mainViewComponent }
];



// WEBPACK FOOTER //
// ./src/app/app.routes.ts